module.exports = __webpack_public_path__ + "static/media/AutoCAD for Mac.6d672aad.png";